/* eslint no-use-before-define: ["error", { "variables": false }] */

import { StyleSheet, Text, View } from 'react-native-web';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * 统一的输入工具栏按钮组件
 * 用于表情包、语音输入、键盘输入、上传文件等输入相关的辅助功能按钮
 *
 * 样式规范：
 * - 尺寸：26x26px
 * - Hover：黑色圆形背景 + 图标反转
 * - Label：fontSize: 9, color: 'black'
 */
export default class InputToolbarButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
  }

  renderIcon() {
    const { renderIcon, renderHoverIcon, disabled } = this.props;
    const { isHovered } = this.state;

    if (!renderIcon) {
      return null;
    }

    // 如果禁用，不显示hover效果
    if (disabled) {
      return renderIcon();
    }

    // Hover状态：黑色圆形背景 + 图标反转
    if (isHovered && renderHoverIcon) {
      return renderHoverIcon();
    }

    return renderIcon();
  }

  render() {
    const { label, onPress, disabled, containerStyle, testID, accessibilityLabel } = this.props;
    const { isHovered } = this.state;

    return (
      <View style={[styles.container, containerStyle]}>
        <View
          testID={testID}
          accessibilityLabel={accessibilityLabel}
          style={[styles.button, disabled && styles.buttonDisabled, isHovered && !disabled && styles.buttonHovered]}
          onMouseEnter={() => !disabled && this.setState({ isHovered: true })}
          onMouseLeave={() => this.setState({ isHovered: false })}
          onClick={disabled ? undefined : onPress}
        >
          {this.renderIcon()}
        </View>
        {label && <Text style={[styles.label, disabled && styles.labelDisabled]}>{label}</Text>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: 26,
    minHeight: 26,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  button: {
    width: 26,
    height: 26,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative'
  },
  buttonHovered: {
    // Hover效果由renderHoverIcon中的黑色圆形背景处理
  },
  buttonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  label: {
    fontSize: 9,
    color: 'var(--idigest-chat-fg, #000000)',
    marginTop: 2,
    textAlign: 'center',
    whiteSpace: 'nowrap'
  },
  labelDisabled: {
    opacity: 0.5
  }
});

InputToolbarButton.defaultProps = {
  renderIcon: null,
  renderHoverIcon: null,
  label: null,
  onPress: () => {},
  disabled: false,
  containerStyle: {},
  testID: null,
  accessibilityLabel: null
};

InputToolbarButton.propTypes = {
  renderIcon: PropTypes.func,
  renderHoverIcon: PropTypes.func,
  label: PropTypes.string,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  containerStyle: PropTypes.object,
  testID: PropTypes.string,
  accessibilityLabel: PropTypes.string
};
